import DATATABLE_TRANSLATIONS from "./datatable_translations";

export default class ExtLanguageCourseExamsDataTable {
  constructor() {
    $(document).ready(function () {
      showExtLanguageCourseExamsTable()
    });

    $(document).on("turbo:render", function () {
      showExtLanguageCourseExamsTable()
    });

    function showExtLanguageCourseExamsTable() {
      $('#ext-language-course-exam-datatable').dataTable({
        "order": [],
        "columnDefs": [{
          "targets": 'no-sort',
          "orderable": false,
        }],
        "language": DATATABLE_TRANSLATIONS,
        "processing": true,
        "serverSide": true,
        "ajax": {
          "url": $('#ext-language-course-exam-datatable').data('source')
        },
        "pagingType": "full_numbers",
        "columns": [
          { "data": "name" },
          { "data": "active" },
          { "data": "actions" }
        ]
        // pagingType is optional, if you want full pagination controls.
        // Check dataTables documentation to learn more about
        // available options.
      });
    }
  }
}
